module.exports = __webpack_public_path__ + "img/odometer.cbd02f29.svg";